import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M10.5 17H8C5.23858 17 3 14.7614 3 12C3 9.23858 5.23858 7 8 7H11M8.5 19.5L10.5 17L8.5 14.5M13.5 12H21.5M13.5 7H21.5M13.5 17H21.5" vectorEffect="non-scaling-stroke" />
	</SVG>
);
